var _rect, _rect2, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg1Month(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    fill: "#E365B1",
    fillOpacity: 0.08
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 39,
    height: 39,
    rx: 11.5,
    stroke: "#E365B1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.001 11.5C25.7722 11.5 27.6578 11.5 28.8294 12.7448C30.001 13.9896 30.001 15.9931 30.001 20C30.001 24.0069 30.001 26.0104 28.8294 27.2552C27.6578 28.5 25.7722 28.5 22.001 28.5L18.001 28.5C14.2297 28.5 12.3441 28.5 11.1725 27.2552C10.001 26.0104 10.001 24.0069 10.001 20C10.001 15.9931 10.001 13.9896 11.1726 12.7448C12.3441 11.5 14.2297 11.5 18.001 11.5L22.001 11.5Z",
    stroke: "#E365B1",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.513 24.5H14.289V17.444H12.717V16.388H15.513V24.5ZM18.2739 24.5H17.0619V18.14H18.1899V19.196C18.6219 18.464 19.3059 18.02 20.1819 18.02C21.1179 18.02 21.8259 18.5 22.1139 19.34C22.5579 18.524 23.2899 18.02 24.2619 18.02C25.5699 18.02 26.4099 18.872 26.4099 20.384V24.5H25.1979V20.768C25.1979 19.712 24.7299 19.088 23.8419 19.088C23.0139 19.088 22.3419 19.784 22.3419 20.852V24.5H21.1299V20.768C21.1299 19.712 20.6619 19.088 19.7739 19.088C18.9339 19.088 18.2739 19.784 18.2739 20.852V24.5Z",
    fill: "#E365B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1Month);
export default __webpack_public_path__ + "static/media/1month.e3561ea734eee6d4bafbc53ac9f14592.svg";
export { ForwardRef as ReactComponent };